<template>
  <div class="apply-company">
    <div>
      <div v-if="isApplyDetail" class="apply-detail">
        <!-- left-text="返回"
  right-text="按钮" 
   left-arrow @click-left="onClickLeft"
  @click-right="onClickRight"-->
        <van-nav-bar title="双选会" />
        <div class="company">
          <ul class="apply-list">
            <li>
              <div class="section-wrap">
                <div class="section-wrap-left">
                  <!-- <img src="../../../assets/img/login-bg.png" alt="" /> -->
                  <van-image
                    width="100%"
                    height="200"
                    fit="contain"
                    :src="item.logoPath"
                  />
                </div>
                <div class="section-wrap-right">
                  <h3>
                    {{ item.name }}
                  </h3>
                  <div class="descript">
                    <van-tag type="primary">{{ item.content }}</van-tag>
                  </div>

                  <!-- <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="3" :xl="1"></el-col>
                </el-row> -->
                  <p>
                    <span
                      ><em>时间：</em>{{ item.startTime }}~{{
                        item.endTime
                      }}</span
                    >
                  </p>
                  <p>
                    <span><em>主办方：</em>{{ item.firstHandle }}</span
                    ><span><em>从办方：</em>{{ item.secondHandle }}</span>
                  </p>
                </div>
              </div>
              <div class="wrap-but">
                <ul>
                  <li>
                    <p class="number">{{ item.companyNum }}</p>
                    <p class="name">参加企业</p>
                  </li>
                  <li>
                    <p class="number">{{ item.postNum }}</p>
                    <p class="name">岗位数量</p>
                  </li>
                  <li>
                    <p class="number">{{ item.recruitNum }}</p>
                    <p class="name">招聘人数</p>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div class="mt-20 company-list">
          <ul v-if="dataList.length > 0">
            <li v-for="(v, i) in dataList" :key="i">
              <div class="top">
                <span><img :src="v.logoPath" alt="" /></span>
                <h3>{{ v.name }}</h3>
              </div>
              <div class="tag" v-if="v.postList!=null&&v.postList.length>0">
                <van-tag v-for="(p, index) in v.postList" type="primary">{{
                  p.name
                }}</van-tag>
                <!-- <ul>
                  <li v-for="(p, index) in v.postList">{{ p.name }}</li>
                </ul> -->
              </div>
              <div class="info">
                <p><span>企业规模：</span>{{ v.scale }}</p>
                <p><span>公司地址：</span>{{ v.address }}</p>
                <p><span>企业网址：</span>{{ v.website }}</p>
              </div>
              <div class="link" @click="goCompany(v.meetingCompanyId)">
                查看招聘岗位
              </div>
            </li>
          </ul>
          <!-- <el-empty v-else description="暂无企业参与该双选会"></el-empty> -->
        </div>
      </div>
      <!-- <CompanyDetail
      v-if="!isApplyDetail"
      :source="source"
      @goBackApply="goBackApply"
      :meetingCompanyId="meetingCompanyId"
      :isMobile="isMobile"
    ></CompanyDetail> -->
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import md5 from "js-md5";
import { Toast } from "vant";
import { getUUID } from "@/utils";
import { login, meetingCompanyList, meetingInfo } from "@/api/common";
export default {
  data() {
    return {
      isApplyDetail: true,
      source: 1,
      dataList: [],
      meetingCompanyId: 0,
      item: {},
      id: 0,
      uuid: "",
      uploadUrlPre:"https://mhys-cloud-class.oss-cn-beijing.aliyuncs.com/jyglUpload/"
    };
  },
  mounted() {
    this.login();
    let href = window.location.href;
    console.log(window.location);
    let query = this.queryURLParams(href);
    console.log(query);
    this.id = query.e.slice(36);
    // this.id = 2;
  },
  methods: {
    isMobile() {
      var userAgentInfo = navigator.userAgent;

      var mobileAgents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      ];

      var mobile_flag = false;

      //根据userAgent判断是否是手机
      for (var v = 0; v < mobileAgents.length; v++) {
        if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
          mobile_flag = true;
          break;
        }
      }
      var screen_width = window.screen.width;
      var screen_height = window.screen.height;

      //根据屏幕分辨率判断是否是手机
      if (screen_width > 325 && screen_height < 750) {
        mobile_flag = true;
      }
      this.isMobile = mobile_flag;
      console.log("this.isMobile", this.isMobile);
    },
    login() {
      this.uuid = getUUID();
      let params = {
        sign: md5(this.uuid + "mhys!123456"),
        uuid: this.uuid
      };
      //
      console.log(params);
      login(params).then(({ data }) => {
        if (data && data.code === 200) {
          this.$cookie.set("apiToken", data.data.apiToken, data.data.expire);
          this.getMeeting(this.id);
          this.getDataList();
        } else {
          // this.$message.error(data.msg);
        }
      });
    },
    queryURLParams(url) {
      let pattern = /(\w+)=(\w+)/gi; //定义正则表达式
      let parames = {}; // 定义参数对象
      url.replace(pattern, ($, $1, $2) => {
        parames[$1] = $2;
      });
      return parames;
    },
    /**
     * @name: 双选会信息
     */
    getMeeting(id) {
      meetingInfo(id).then(({ data }) => {
        if (data && data.code === 200) {
          if (
            data.data.logoPath &&
            data.data.logoPath != null &&
            data.data.logoPath != ""
          ) {
            // data.data.logoPath = this.$htp({url:(process.env.NODE_ENV != 'production' ?"/proxyApi":window.SITE_CONFIG.baseUrl)});
            // window.SITE_CONFIG.base_url_dev

            // data.data.logoPath = "http://192.168.6.138:7010/mhys/"+data.data.logoPath;
            // data.data.logoPath =
            //   window.SITE_CONFIG.base_url_dev + "/" + data.data.logoPath;
              //  data.data.logoPath =
              //     process.env.NODE_ENV != "production"
              //       ? window.SITE_CONFIG.base_url_dev + "/" + data.data.logoPath
              //       : window.SITE_CONFIG.base_url + "/" + data.data.logoPath;
                     data.data.logoPath =this.uploadUrlPre + data.data.logoPath;
          } else {
            data.data.logoPath = require("../assets/img/apply-img-empty.png");
          }
          this.item = data.data;
        }
      });
    },
    /**
     * @name: 企业数据列表
     */
    getDataList() {
      this.dataListLoading = true;
      let params = {
        // page: this.pageIndex,
        // limit: this.pageSize,
        meetingId: this.id
        // status: "1"
      };
      meetingCompanyList(params).then(({ data }) => {
        if (data && data.code === 200) {
          if (data.data != null) {
            // console.log(12,process.env.NODE_ENV);
            // console.log(43,window.SITE_CONFIG.base_url_dev);
            // let url=process.env.NODE_ENV != "production"
            //         ? window.SITE_CONFIG.base_url_dev + "/"
            //         : window.SITE_CONFIG.base_url + "/";    
            data.data.forEach(e => {
              if (e.logoPath && e.logoPath != null && e.logoPath != "") {
                e.logoPath =this.uploadUrlPre + e.logoPath;
              } else {
                e.logoPath = require("../assets/img/company-img-empty.png");
                e.logoPathUrl = "";
              }
            });
            this.dataList = data.data;
            // this.totalPage = data.data.totalCount;
          }
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });
    },
    goBack() {
      this.$emit("step", 1);
    },
    // 企业报名
    addOrUpdateHandle(id) {
      this.$emit("step", 3, this.id, 1);
    },
    goCompany(id) {
      // this.meetingCompanyId = id;
      // this.isApplyDetail = false;
      this.$router.push({
        name: "ApplyPost",
        query: {
          meetingCompanyId: id
        }
      });
    },
    goBackApply() {
      this.isApplyDetail = true;
      // this.$router.push({
      //         name: "companyDetail",
      //         query: {
      //             meetingCompanyId:this.meetingCompanyId,
      //             isMobile:this.isMobile
      //         },
      //     });
    }
  }
};
</script>
<style lang="scss" scoped>
$--color-primary: #266eff;
.apply-company {
  font-size: 0.36rem;
  color: #323233;
  .company {
    .apply-list {
      margin: 0;
      padding: 0 0.3rem;
      overflow: auto;
      background: #f8f8f8;

      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.2rem 0;
      }

      .section-wrap {
        display: flex;
        // align-items: center;

        .section-wrap-left {
          margin-right: 0.3rem;

          // img {
          //   width: 200px;
          //   height: 120px;
          //   border-radius: 4px;
          // }
        }

        .section-wrap-right {
          h3 {
            font-size: 0.44rem;
            margin: 0 0 0.2rem;
            padding-top: 0.15rem;
            font-weight: normal;
          }

          .descript {
            margin-bottom: 0.18rem;

            span {
              // display: inline-block;
              background: #e6ebfb;
              // padding: 0 0.1rem;
              // border-radius: 0.04rem;
              // font-size: 0.16rem;
              color: $--color-primary;
              // line-height: 0.32rem;
            }
          }

          p {
            span {
              display: inline-block;
              margin-right: 0.25rem;
              height: 0.5rem;
              line-height: 0.6rem;
              margin-bottom: 0.2rem;
            }

            em {
              font-style: normal;
              color: #999;
            }
          }
        }
      }

      .wrap-but {
        width: 4rem;
        flex-shrink: 0;
        margin-top: 0.4rem;
        ul {
          display: flex;

          li {
            flex-direction: column;
            width: 100%;
          }
        }

        .number {
          font-size: 0.5rem;
        }

        .name {
          color: #999;
          margin-top: 0.2rem;
          font-size: .34rem;
        }
      }
    }
  }

  .company-list {
    padding-bottom: 0.2rem;

    > ul {
      list-style: none;
      margin: 0.15rem;
      padding: 0;
      overflow: hidden;

      > li {
        float: left;
        // display: flex;
        // flex-direction: column;
        width: calc(25% - 0.26rem);
        border: 1px solid #e8e8e8;
        border-radius: 0.04rem;
        margin: 0.15rem;
        padding-top: 0.15rem;

        .top {
          display: flex;
          align-items: center;
          padding: 0.25rem 0.26rem 0.3rem;
          height: 1rem;

          h3 {
            width: calc(100% - 0.73rem);
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            font-size: .4rem;
            color: #000;
          }

          span {
            width: 1rem;
            height: 1rem;
            margin-right: 0.2rem;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          img {
            border-radius: 0.08rem;
            // border: 1px solid #e8e8e8;
            width: 1rem;
            height: 1rem;
          }

          i {
            display: inline-block;
            width: 0.6rem;
            height: 0.6rem;
            background: rgb(47, 130, 255);
            color: #fff;
            font-style: normal;
            line-height: 0.6rem;
            text-align: center;
            font-size: 0.24rem;
            border-radius: 0.08rem;
            border: 1px solid rgb(47, 130, 255);
          }
        }

        .tag {
          padding: 0 0.26rem;
          // height: .6rem;
          overflow: hidden;
          margin-bottom: .1rem;
          span {
            // float: left;
            // display: inline-block;
            background: #e6ebfb;
            // padding: 0 0.44rem;
            // border-radius: 0.04rem;
            // font-size: 0.16rem;
            color: $--color-primary;
            // height: 0.32rem;
            // line-height: 0.32rem;
            margin-right: 0.2rem;
          }
        }

        .info {
          padding: 0.1rem 0.26rem 0.2rem;
          p {
            height: 0.7rem;
            line-height: 0.7rem;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          span {
            color: #999;
          }
        }

        .link {
          background: #f9fafe;
          height: 1rem;
          line-height: 1rem;
          text-align: center;
          color: #fe7e40;
          font-size: .4rem;
          cursor: pointer;
        }
      }
    }
  }
}
@media only screen and (max-width: 1200px) {
  .apply-company .company-list > ul > li .tag {
    height: 0.5rem;
  }
  .apply-company .company-list {
    > ul {
      > li {
        width: calc(50% - 0.35rem);
      }
    }
  }
  .apply-company .company .apply-list li {
    display: block;
    // padding: 0.44rem 0;
    .wrap-but {
      border-top: 1px solid #e8e8e8;
      text-align: center;
      // margin-top: 20px;
      width: 100%;
    }
  }
}
@media only screen and (max-width: 700px) {
  .apply-company .company-list > ul > li .tag {
    height: auto;
  }
  .apply-detail .company .apply-list .section-wrap {
    display: block;
    .section-wrap-left {
      margin-right: 0;
      img {
        width: 100%;
        height: auto;
      }
    }
    .section-wrap-right {
      h3 {
        margin-top: 0.16rem;
        
            color: #000;
      }
      p span {
        display: block;
      }
    }
  }
  .apply-detail {
    margin: 0 auto;
  }
  .apply-company .company-list {
    > ul {
      > li {
        width: calc(100% - 0.6rem);
      }
    }
  }
}
// @media only screen and (max-width: 500px) {
//   .apply-detail .company .apply-list .section-wrap {
//     display: block;
//     .section-wrap-left {
//       margin-right: 0;
//       img {
//         width: 100%;
//         height: auto;
//       }
//     }
//     .section-wrap-right {

//       h3 {
//         margin-top: 0.16rem;
//       }
//       p span {
//         display: block;
//       }
//     }
//   }
//   .apply-detail {
//     margin: 0 auto;
//   }
// }
</style>



<style lang="scss">
@media only screen and (min-width: 700px) {
  .apply-company .van-image__error,
  .van-image__img,
  .van-image__loading {
    width: 5.2rem;
  }
}
</style>